<template>
  <div class="flex items-center gap-2">
    <img v-if="statusConfig?.icon" :src="statusConfig?.icon" />
    <p
      v-show="showText"
      :class="statusConfig?.textColor"
      class="text-sm font-medium"
    >
      {{ text ?? "N/A" }}
    </p>
  </div>
</template>

<script>
import redFlag from "../../../../assets/svg/red-flag.svg";
import yellowFlag from "../../../../assets/svg/yellow-flag.svg";
import blueFlag from "../../../../assets/svg/blue-flag.svg";
import { lowerCase } from "@/core/helpers/utility";
export default {
  name: "FlagColumn",
  props: {
    text: {
      type: String,
      required: true,
      default: "",
    },
    showText: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      textColor: "text-gray-600",
      redFlag,
      yellowFlag,
      blueFlag,
      currentIcon: "",
    };
  },
  computed: {
    statusConfig() {
      if (!this.text) {
        return {
          icon: null,
          textColor: "text-gray-600",
        };
      }

      const text = this.text?.trim().toLowerCase();
      if (text === "high") {
        return {
          icon: this.redFlag,
          textColor: "text-[#D44333]",
        };
      } else if (
        text === "low" ||
        text === "due" ||
        text === "due for maintenance" ||
        text === "undergoing maintenance"
      ) {
        return {
          icon: this.yellowFlag,
          textColor: "text-[#BC8B2C]",
        };
      } else if (
        text === "medium" ||
        text === "ok" ||
        text === "working fine"
      ) {
        return {
          icon: this.blueFlag,
          textColor: "text-blue-500",
        };
      }

      // Default case
      return {
        icon: null,
        textColor: "text-gray-600",
      };
    },
  },
  mounted() {},
};
</script>

<style>
/* table columns styling options */
.positive {
  font-weight: 500;
  font-size: 14px;
  color: #155c22;
}

.negative {
  font-weight: 500;
  font-size: 14px;
  color: #e11900;
}
</style>
